import { datadogLogs } from "@datadog/browser-logs";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { Redirect } from "./app/redirect";
import { DATADOG_CLIENT_TOKEN, SENTRY_DSN } from "./config";
import { loginRoutes } from "./login/route";
import { orderRoutes } from "./order/routes";
import { returnRoutes } from "./return/routes";
import { Root } from "./root";
import "./styles.css";
import { setFavicon } from "./utils/utils";

if (SENTRY_DSN) {
  Sentry.init({ dsn: SENTRY_DSN });
}

if (DATADOG_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

// Captures the "/widget_id/*" from the path to use as the prefix for local development
// and when loading the return portal directly from returns.getredo.com (complete exchange links)
const WIDGET_ID_PATH_PREFIX = /^(\/widget_id\/[^/]+).*/;

let basename =
  base_path && base_path !== "base_path"
    ? base_path
    : WIDGET_ID_PATH_PREFIX.test(window.location.pathname)
    ? window.location.pathname.replace(WIDGET_ID_PATH_PREFIX, "$1")
    : "/";

const queryParams = new URLSearchParams(window.location.search);
const hash = window.location.hash;
if (hash.startsWith("#/")) {
  if (basename === "/" && queryParams.has("widget_id")) {
    basename = `/widget_id/${queryParams.get("widget_id")}/`;
  }
  const newURL = new URL(
    `${basename}/returns-portal/${hash.slice(1)}`.replaceAll("//", "/"),
    window.location.origin,
  );
  queryParams.forEach((value, key) => {
    if (key !== "widget_id") {
      newURL.searchParams.append(key, value);
    }
  });
  window.location.href = newURL.toString();
  console.log("newURL", newURL);
}

const router = createBrowserRouter(
  [
    {
      path: "/returns-portal",
      children: [
        {
          element: <Root />,
          errorElement: <div>Not Found</div>,
          children: [
            {
              index: true,
              element: <Redirect to="login" preserveQuery />,
            },
            {
              path: "login",
              element: <Outlet />,
              children: loginRoutes,
            },
            {
              path: "orders",
              element: <Outlet />,
              children: orderRoutes,
            },
            {
              path: "returns",
              element: <Outlet />,
              children: returnRoutes,
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <Redirect to="/returns-portal" preserveQuery />,
    },
  ],
  {
    basename,
  },
);

void setFavicon();
const root = createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
